import { render, staticRenderFns } from "./TimeDefault.vue?vue&type=template&id=06339c35&scoped=true"
import script from "./TimeDefault.vue?vue&type=script&lang=js"
export * from "./TimeDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06339c35",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06339c35')) {
      api.createRecord('06339c35', component.options)
    } else {
      api.reload('06339c35', component.options)
    }
    module.hot.accept("./TimeDefault.vue?vue&type=template&id=06339c35&scoped=true", function () {
      api.rerender('06339c35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/widget/deWidget/TimeDefault.vue"
export default component.exports